<template>
    <div v-if="route" class="madrid-route" :style="{overflowY: showQuiz ? 'hidden' : 'visible'}">
        <div class="madrid-route__back" @click="goBack()"></div>
        <div class="madrid-route__image" :style="{ backgroundImage: `url(${route.image})` }">
            <div @click="goToMap()" class="madrid-route__go">
                <span>COMENZAR RUTA</span>
                <span></span>
            </div>
        </div>
        <div class="madrid-route__content">
            <div>
                <span>DISTRITO</span>
                <span>{{ route.locations.length }} PARADAS</span>
            </div>
            <h1>{{ route.name }}</h1>
            <p>{{ route.description }}</p>
            <img :src="route.map"/>
            <p>{{ route.description_district }}</p>
            <madrid-directions :directions="directions"></madrid-directions>
            <div class="madrid-route__bottom">
                <div @click="goToMap()" class="madrid-route__go">
                    <span>COMENZAR RUTA</span>
                    <span></span>
                </div>
                <div></div>
            </div>
        </div>
        <madrid-quiz v-if="showQuiz" @back="hideQuiz" :route="name" 
        :type="QuizType.INIT"></madrid-quiz>
    </div>
</template>
<script src="./RouteComponent.ts" lang="ts"></script>
<style lang="scss" src="./RouteComponent.scss"></style>